import React from "react";
//import PropTypes from 'prop-types';

import {
    ListItem as BaseListItem,
    MenuItems as BaseMenuItems,
} from "playground/cms/views/Resources";

export function ListItem(props) {
    const {} = props;
    return (
        <BaseListItem
            {...props}
            primaryTextProperties={["name", "code_part"]}
        />
    );
}

ListItem.propTypes = {};

ListItem.defaultProps = {};

export default ListItem;
